export const DATE_TIME_API = 'yyyy-MM-dd HH:mm:ss';
export const DATE_TIME_TO_CONTROL_DATE = 'yyyy-MM-dd\'T\'HH:mm:ss';
export const DATE_API = 'yyyy-MM-dd';
export const HOUR_AND_MINUTE_API = 'HH:mm:ss';
